/** @format */
import { getFilePreviewUrlById } from '@power/runtime-vue3';
export const getImgUrl = (id: string) => {
	return getFilePreviewUrlById(id);
};
